/* CAR'CONFORT v2 — petits comportements globaux */
(function () {
  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: cur });
  }

  /* Jauge « livraison offerte » : se met à jour après chaque ajout / modification du panier */
  function refreshShipbars(cart) {
    var bars = document.querySelectorAll('[data-cc2-shipbar]');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || 3000;
      var total = cart.total_price || 0;
      var remaining = threshold - total;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var text = bar.querySelector('[data-cc2-shipbar-text]');
      var fill = bar.querySelector('[data-cc2-shipbar-fill]');
      if (fill) fill.style.width = pct + '%';
      if (text) {
        text.innerHTML = remaining > 0
          ? 'Plus que <strong>' + fmt(remaining) + '</strong> pour la livraison offerte'
          : '<strong>Livraison offerte</strong> sur votre commande';
      }
    });
  }

  function fetchCartAndRefresh() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(refreshShipbars)
      .catch(function () {});
  }

  function boot() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(fetchCartAndRefresh, 150); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
